module.exports = __webpack_public_path__ + "img/monitoring_plan_black.5c889c06.svg";